import { render, staticRenderFns } from "./IsAdetRaporuTable.vue?vue&type=template&id=47a8d612&"
import script from "./IsAdetRaporuTable.vue?vue&type=script&lang=js&"
export * from "./IsAdetRaporuTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports